import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { collaborateTrust } from "@/mocks/collaborateData";

export default function CollaborateTrust() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
            {collaborateTrust.stats.map((stat, index) => (
              <ScrollReveal key={stat.label} delay={index * 100}>
                <div className="p-5 md:p-6 rounded-xl bg-tie-grey-light border border-tie-grey-dark text-center">
                  <p className="font-serif text-3xl md:text-4xl font-bold text-tie-navy">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-sm font-semibold text-tie-text-primary">
                    {stat.label}
                  </p>
                  <p className="mt-0.5 text-xs text-tie-text-muted">
                    {stat.sub}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Quote */}
          <ScrollReveal delay={200}>
            <div className="max-w-3xl mx-auto text-center">
              <div className="relative">
                <div className="text-5xl md:text-6xl text-tie-teal/20 font-serif leading-none mb-2">
                  &ldquo;
                </div>
                <p className="text-lg md:text-xl text-tie-text-primary leading-relaxed -mt-6 md:-mt-8">
                  {collaborateTrust.quote.text}
                </p>
                <div className="mt-6 flex items-center justify-center gap-3">
                  <div className="h-px w-8 bg-tie-grey-dark" />
                  <p className="text-sm font-semibold text-tie-text-secondary">
                    {collaborateTrust.quote.author}
                  </p>
                  <p className="text-sm text-tie-text-muted">
                    {collaborateTrust.quote.company}
                  </p>
                  <div className="h-px w-8 bg-tie-grey-dark" />
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}